import {
  buildTagsById
} from "./utils/spot_utils";
import { buildCategoriesById, buildCategoryIcons } from "./category_icons";
import { setupFeedbackPanel } from "./feedback_panel";
import { setupHelpPanel } from "./help_panel";
import { createMapInstance, createModeController } from "./map_state";
import { createSpotsListController } from "./spots_list";
import { setupSearchPanel } from "./search_panel";
import { createPopupController } from "./popup_renderer";
import { setupCurrentLocationButton } from "./current_location";
import { setupMapEventBindings } from "./map_events";

document.addEventListener("DOMContentLoaded", () => {
  const mapElement = document.getElementById("map");
  if (!mapElement || !window.mapboxgl) return;

  const accessToken = mapElement.dataset.mapboxAccessToken;
  if (!accessToken) return;

  mapboxgl.accessToken = accessToken;

  const tilesetId = mapElement.dataset.tilesetId;
  const sourceLayer = mapElement.dataset.sourceLayer;
  const categories = JSON.parse(mapElement.dataset.categories || "[]");
  const wirelessTags = JSON.parse(mapElement.dataset.wirelessTags || "[]");
  const otherTags = JSON.parse(mapElement.dataset.otherTags || "[]");
  const infoIconSize = mapElement.dataset.infoIconSize || "30";
  const imageBaseUrl = mapElement.dataset.imageBaseUrl || "";
  const pageMode = mapElement.dataset.pageMode || "map";
  const disableViewportUrlSync = pageMode === "spot-detail";

  const categoriesById = buildCategoriesById(categories);
  const wirelessTagsById = buildTagsById(wirelessTags, infoIconSize, imageBaseUrl);
  const otherTagsById = buildTagsById(otherTags, infoIconSize, imageBaseUrl);
  const icons = buildCategoryIcons(categories, imageBaseUrl);

  const initialLat = mapElement.dataset.initialLat;
  const initialLng = mapElement.dataset.initialLng;
  const initialZoom = mapElement.dataset.initialZoom;
  let mapSearch = window.location.search;
  if (initialLat && initialLng) {
    const initialParams = new URLSearchParams(mapSearch);
    initialParams.set("ll", `${initialLat},${initialLng}`);
    if (initialZoom) initialParams.set("z", initialZoom);
    mapSearch = initialParams.toString();
  }

  const map = createMapInstance({
    mapboxgl,
    containerId: "map",
    search: mapSearch
  });

  const spotsPath = mapElement.dataset.spotsPath;
  const spotsListElement = document.getElementById("spots-list");
  const spotsSummaryElement = document.getElementById("spots-summary");
  const spotsLoadingElement = document.getElementById("spots-loading");
  const spotsEmptyElement = document.getElementById("spots-empty");
  const spotsErrorElement = document.getElementById("spots-error");
  const POWER_SUPPLY_TAGS = "電源:お客様用コンセント,電源:壁コンセント,電源:USB";
  const spotsListController = createSpotsListController({
    map,
    spotsPath,
    infoIconSize,
    otherTagsById,
    wirelessTagsById,
    elements: {
      list: spotsListElement,
      summary: spotsSummaryElement,
      loading: spotsLoadingElement,
      empty: spotsEmptyElement,
      error: spotsErrorElement
    },
    powerSupplyTags: POWER_SUPPLY_TAGS,
    imageBaseUrl
  });

  const modeController = createModeController({
    map,
    infoTextElement: document.getElementById("filter-info-text"),
    onModeChanged: () => spotsListController.refreshVisibleSpots()
  });

  const popupController = createPopupController({
    map,
    mapboxgl,
    categoriesById,
    otherTagsById,
    wirelessTagsById,
    infoIconSize,
    imageBaseUrl
  });

  setupMapEventBindings({
    map,
    modeController,
    spotsListController,
    popupController,
    tilesetId,
    sourceLayer,
    icons,
    shouldSyncUrl: !disableViewportUrlSync
  });

  if (!disableViewportUrlSync) {
    setupCurrentLocationButton({
      map,
      button: document.getElementById("move-current-location")
    });
  }

  if (!disableViewportUrlSync) {
    setupSearchPanel({
      map,
      elements: {
        panel: document.getElementById("search-panel"),
        openButton: document.getElementById("search-button"),
        closeButton: document.getElementById("search-close"),
        input: document.getElementById("search-input"),
        submit: document.getElementById("search-submit"),
        error: document.getElementById("search-error")
      }
    });
  }

  if (!disableViewportUrlSync) {
    setupFeedbackPanel({
      elements: {
        panel: document.getElementById("feedback-panel"),
        toggleButton: document.getElementById("feedback-button"),
        closeButton: document.getElementById("feedback-close"),
        contributeLink: document.getElementById("contribute-link")
      }
    });
  }

  if (!disableViewportUrlSync) {
    setupHelpPanel({
      elements: {
        panel: document.getElementById("help-panel"),
        toggleButton: document.getElementById("help-button"),
        closeButton: document.getElementById("help-close")
      }
    });
  }
});
